"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationListFilter = exports.reservationListFilterConfig = exports.className = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const dateTime_1 = require("../../../../utils/dateTime");
const Button_1 = require("../../../Button");
const Multiple_1 = require("../../../CheckBox/Multiple");
const stable_1 = require("../../../CheckBox/stable");
const Field_1 = require("../../../Form/Field");
const stable_2 = require("../../../Form/Field/DateRange/stable");
const BadgeMultiSelect_1 = require("../../../Form/Field/MultiSelect/BadgeMultiSelect");
const SearchUser_1 = require("../../../Form/Field/SearchUser");
const utils_1 = require("../../../Form/Field/SearchUser/utils");
const utils_2 = require("./utils");
require("./index.scss");
exports.className = 'reservation-list-filter';
const reservationListFilterConfig = (value) => {
    var _a, _b, _c;
    return ({
        type: 'object',
        optional: true,
        shape: {
            query: {
                type: 'string',
                optional: true,
                modificators: 'search',
            },
            isActive: {
                type: 'boolean',
                optional: true,
                modificators: 'inline-zero',
            },
            reservationStatus: {
                type: 'array',
                optional: true,
                items: [
                    'created',
                    'confirmed',
                    'reserved',
                    'cancelled',
                ],
            },
            paymentStatus: {
                type: 'array',
                optional: true,
                items: [
                    'paid',
                    'unpaid',
                ],
            },
            flightDateInterval: {
                type: 'object',
                optional: true,
                modificators: 'together',
                dateRestrictions: {
                    pastYearsCount: dateTime_1.bookingFilterPastYearsCount,
                    nextYearsCount: dateTime_1.bookingNextYearsCount,
                },
                shape: {
                    from: {
                        type: 'date',
                        optional: true,
                    },
                    to: {
                        type: 'date',
                        optional: true,
                        dateRestrictions: {
                            notAllowedBeforeDate: (_a = value === null || value === void 0 ? void 0 : value.flightDateInterval) === null || _a === void 0 ? void 0 : _a.from,
                        },
                    },
                },
            },
            createdAtInterval: {
                type: 'object',
                optional: true,
                modificators: 'together',
                dateRestrictions: {
                    pastYearsCount: dateTime_1.bookingFilterPastYearsCount,
                    nextYearsCount: dateTime_1.bookingNextYearsCount,
                },
                shape: {
                    from: {
                        type: 'date',
                        optional: true,
                    },
                    to: {
                        type: 'date',
                        optional: true,
                        dateRestrictions: {
                            notAllowedBeforeDate: (_b = value === null || value === void 0 ? void 0 : value.createdAtInterval) === null || _b === void 0 ? void 0 : _b.from,
                        },
                    },
                },
            },
            paymentDateInterval: {
                type: 'object',
                optional: true,
                modificators: 'together',
                dateRestrictions: {
                    pastYearsCount: dateTime_1.bookingFilterPastYearsCount,
                    nextYearsCount: dateTime_1.bookingNextYearsCount,
                },
                shape: {
                    from: {
                        type: 'date',
                        optional: true,
                    },
                    to: {
                        type: 'date',
                        optional: true,
                        dateRestrictions: {
                            notAllowedBeforeDate: (_c = value === null || value === void 0 ? void 0 : value.paymentDateInterval) === null || _c === void 0 ? void 0 : _c.from,
                        },
                    },
                },
            },
            reservator: {
                type: 'object',
                optional: true,
            },
            owner: {
                type: 'object',
                optional: true,
            },
            paymentTerms: {
                optional: true,
                type: 'array',
                items: utils_2.paymentTerms,
            },
        },
    });
};
exports.reservationListFilterConfig = reservationListFilterConfig;
const ReservationListFilter = (props) => {
    const { field, submit, reset, } = props;
    const { formatMessage } = (0, react_intl_1.useIntl)();
    return (react_1.default.createElement("div", { className: exports.className },
        react_1.default.createElement("div", { className: `${exports.className}__form` },
            react_1.default.createElement(Field_1.FormFieldStable, { ...field(['query']), placeholder: formatMessage({
                    id: 'components/Reservation/List:searchPlaceholder',
                    defaultMessage: 'Search',
                }), additionClassNames: `${exports.className}__search`, prefixIcon: 'search' }),
            react_1.default.createElement(Button_1.Button, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:SearchButton', defaultMessage: 'Search' }), modificators: ['ascetic', 'block'], onClick: submit, additionClassNames: `${exports.className}__button` }),
            react_1.default.createElement("div", { className: `${exports.className}__checkbox-groups` },
                react_1.default.createElement(stable_1.CheckBoxStable, { ...field(['isActive']), textRight: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:IsActiveOnly', defaultMessage: 'Active only' }) }),
                react_1.default.createElement(Multiple_1.CheckBoxMultiple, { ...field(['reservationStatus']), title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:Status', defaultMessage: 'Status:' }), toItem: utils_2.mapReservationStatusToItem }),
                react_1.default.createElement(Multiple_1.CheckBoxMultiple, { ...field(['paymentStatus']), title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:Payment', defaultMessage: 'Payment:' }), toItem: utils_2.mapReservationPaymentStatusToItem }))),
        react_1.default.createElement("div", { className: `${exports.className}__form` },
            react_1.default.createElement(stable_2.FormFieldDateRangeStable, { ...field(['flightDateInterval']), additionClassNames: `${exports.className}__range-dates`, fromField: {
                    ...field(['flightDateInterval', 'from']),
                    label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:FlightFrom', defaultMessage: 'Flight from' })),
                }, toField: {
                    ...field(['flightDateInterval', 'to']),
                    label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:FlightTo', defaultMessage: 'To' })),
                } }),
            react_1.default.createElement(stable_2.FormFieldDateRangeStable, { ...field(['createdAtInterval']), additionClassNames: `${exports.className}__range-dates`, fromField: {
                    ...field(['createdAtInterval', 'from']),
                    label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:ReservedFrom', defaultMessage: 'Reserved from' })),
                }, toField: {
                    ...field(['createdAtInterval', 'to']),
                    label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:ReservedTo', defaultMessage: 'To' })),
                } }),
            react_1.default.createElement(stable_2.FormFieldDateRangeStable, { ...field(['paymentDateInterval']), additionClassNames: `${exports.className}__range-dates`, fromField: {
                    ...field(['paymentDateInterval', 'from']),
                    label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:PaidFrom', defaultMessage: 'Paid from' })),
                }, toField: {
                    ...field(['paymentDateInterval', 'to']),
                    label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:PaidTo', defaultMessage: 'To' })),
                } }),
            react_1.default.createElement(SearchUser_1.SearchUser, { ...field(['reservator']), toItem: utils_1.mapUserProfileToUserSearchItem, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:ReservedBy', defaultMessage: 'Reserved by' }), additionClassNames: `${exports.className}__reserved-by` }),
            react_1.default.createElement(SearchUser_1.SearchUser, { ...field(['owner']), toItem: utils_1.mapUserProfileToUserSearchItem, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:OwnedBy', defaultMessage: 'Owned by' }), additionClassNames: `${exports.className}__owned-by` }),
            react_1.default.createElement("div", { className: `${exports.className}__payment-terms` },
                react_1.default.createElement(BadgeMultiSelect_1.BadgeMultiSelect, { ...field(['paymentTerms']), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:PaymentTerms', defaultMessage: 'Payment terms' }), toItem: (value) => ({
                        name: utils_2.paymentTermsMap[value],
                        value,
                    }) })),
            react_1.default.createElement(Button_1.Button, { icon: 'cycle', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:ResetButton', defaultMessage: 'Reset' }), onClick: reset, additionClassNames: `${exports.className}__reset`, modificators: ['ascetic', 'block'] }))));
};
exports.ReservationListFilter = ReservationListFilter;
//# sourceMappingURL=index.js.map